import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { clearSelectStreamEpic } from './_epics/clearSelectStream.epic';
import { initStreamsFilterEpic } from './_epics/initStreamsFilter.epic';
import { toggleSelectNodeStreamEpic } from './_epics/toggleSelectNodeStream.epic';
import { toggleSelectStreamEpic } from './_epics/toggleSelectStream.epic';
import { clearStreamOnNodeSelectEpic } from './_epics/clearStreamOnNodeSelect.epic';

export const streamsFilterEpic = safeCombineEpics(
  clearSelectStreamEpic,
  initStreamsFilterEpic,
  toggleSelectNodeStreamEpic,
  toggleSelectStreamEpic,
  clearStreamOnNodeSelectEpic,
);
